module.exports = __webpack_public_path__ + "media/images/flags/4x3/caf-c2b4d408f6552478bf7bf1e35b98467f.svg";